import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

export let flowStartTime = 0;

export const setFlowStartTime = (time: number) => {
    flowStartTime = time;
};

//istanbul ignore next
export const logCdmsNR = (type: string, status: string, extra?: unknown) => {
    let extraFields: Record<string, unknown> | undefined;
    try {
        if (extra !== undefined) {
            extraFields = { content: JSON.stringify(extra) };
        }
    } catch (_e) {
        // ignore JSON.stringify errors
    }
    logNewRelicPageAction('MV:CDMS', { type, status, durationMs: Date.now() - flowStartTime, ...extraFields });
};
